import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  anonymous_activityBlogsData: any;
  anonymous_activityBlogsLoading: boolean;
  anonymous_activityBlogsError: SerializedError | null;
} = {
  anonymous_activityBlogsData: {},
  anonymous_activityBlogsLoading: false,
  anonymous_activityBlogsError: null,
};

export const anonymous_activityBlogsFunc = createAsyncThunk(
  'anonymous_activityBlogs/anonymous_activityBlogsFunc',
  async (values: { plus: boolean | null }) => {
    const data1 = JSON.stringify({
      query: `query Anonymous_activityBlogs($filter: FilterActivityBlogsByAnonymousInput) {
      anonymous_activityBlogs(filter: $filter) {
        count
        data {
        createdAt
        externalLink
        externalMail
        externalPhoneNumber
        listing {
            coverImage
            description
            title
        }
        _id
        plus
        }
      }
    }`,
      variables: {
        filter: {
          plus: values?.plus ?? null,
        },
      },
    });

    const config = initialConfig(process.env.REACT_APP_BASE_URL_ACTIVITY || '', data1, '');

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const anonymous_activityBlogs = createSlice({
  name: 'anonymous_activityBlogs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(anonymous_activityBlogsFunc.pending, (state) => {
      state.anonymous_activityBlogsLoading = true;
    });
    builder.addCase(anonymous_activityBlogsFunc.fulfilled, (state, action) => {
      state.anonymous_activityBlogsLoading = false;
      state.anonymous_activityBlogsData = action.payload?.data?.anonymous_activityBlogs;
      state.anonymous_activityBlogsError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(anonymous_activityBlogsFunc.rejected, (state, action) => {
      state.anonymous_activityBlogsLoading = false;
      state.anonymous_activityBlogsError = action.error;
    });
  },
});

export default anonymous_activityBlogs.reducer;
